import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_BULK_DELETE_ITEMS_BEGIN,
  COLLECTIONS_BULK_DELETE_ITEMS_SUCCESS,
  COLLECTIONS_BULK_DELETE_ITEMS_FAILURE,
  COLLECTIONS_BULK_DELETE_ITEMS_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function bulkDeleteItems(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_BULK_DELETE_ITEMS_BEGIN,
    });

    const { projectId, collectionName, ids, version } = args;
    console.log('These are the ids: ', args.ids);
    console.log('These are the arguments from the bulkDelete builder api: ', args);

    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/bulkDelete/`,
        {
          headers: header.headers,
          data: { ids: ids },
        },
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: COLLECTIONS_BULK_DELETE_ITEMS_SUCCESS,
              itemId: args.data,
            });
            // toast.success('Item deleted successfully !');
            resolve(res);
          } else {
            console.log('This is the api response: ', res);
            dispatch({
              type: COLLECTIONS_BULK_DELETE_ITEMS_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion Failed: ${errMsg} `);
            reject('Failed');
          }
        },
        (err) => {
          console.log('This is the api response: ', err);
          dispatch({
            type: COLLECTIONS_BULK_DELETE_ITEMS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg} `);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissBulkDeleteItemsError() {
  return {
    type: COLLECTIONS_BULK_DELETE_ITEMS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_BULK_DELETE_ITEMS_BEGIN:
      return {
        ...state,
        bulkDeleteItemsPending: true,
        bulkDeleteItemsError: null,
      };

    case COLLECTIONS_BULK_DELETE_ITEMS_SUCCESS:
      return {
        ...state,
        bulkDeleteItemsPending: false,
        bulkDeleteItemsError: null,
      };

    case COLLECTIONS_BULK_DELETE_ITEMS_FAILURE:
      return {
        ...state,
        bulkDeleteItemsPending: false,
        bulkDeleteItemsError: action.data.error,
      };

    case COLLECTIONS_BULK_DELETE_ITEMS_DISMISS_ERROR:
      return {
        ...state,
        bulkDeleteItemsError: null,
      };

    default:
      return state;
  }
}
